import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectFilters } from '../reducers/filtersReducer';
import { selectOffers } from '../reducers/offersReducer';
import { selectZipCode } from '../reducers/zipCodeReducer';
import applyConfirmedFilters from '../utils/applyConfirmedFilters';

const useShowDetails = (): boolean => {
  const hasWindow = typeof window !== 'undefined';
  const queryParams = new URLSearchParams(hasWindow ? window.location.search : '');
  const hashParams = new URLSearchParams(hasWindow ? window.location.hash.substring(1) : '');
  const searchParams = hashParams.size ? hashParams : queryParams;

  const showDetails = searchParams.get('show-details') === 'true';

  const { offersList } = useSelector(selectOffers);
  const { confirmedFilters } = useSelector(selectFilters);
  const { market } = useSelector(selectZipCode);

  const isCaMarket = market === 'CA';

  const filteredCount = useMemo(() => {
    if (!showDetails) return 0;
    return applyConfirmedFilters(offersList, confirmedFilters, isCaMarket).length;
  }, [showDetails, offersList, confirmedFilters, isCaMarket]);

  return showDetails && filteredCount === 1;
};

export default useShowDetails;
